export default __webpack_public_path__ + "static/media/Logo1.163a09bf.svg";